<template>
    <div
        class="Tag"
        @click="$emit('deselect', value.value)"
    >
        <span class="Tag__label">{{ value.label }}</span>
        <StreamlineIcon
            class="Tag__icon"
            :icon="closeIcon"
            fill="#0A68F2"
            :size="8"
        />
    </div>
</template>
<script>
import StreamlineIcon from "@reviewpush/streamline-icons-vue";
import {Close as CloseIcon} from "@reviewpush/streamline-bold/lib/interface-essential/FormValidation";
export default {
    name: 'Tag',
    components: {
        StreamlineIcon
    },
    props: {
        value: {
            type: Object,
            required: true,
        },
    },
    computed: {
        closeIcon(){
            return CloseIcon;
        }
    }
};
</script>
<style lang="scss">
    .Tag {
        height: fit-content;
        color: $primary;
        font-size: .80rem;
        padding: .25rem 0.5rem;
        margin-right: 0.25rem;
        display:flex;
        background: $primary-50;
        border-radius: 4px;
        width: fit-content;
        cursor: pointer;
        white-space: nowrap;
        margin-bottom: .25rem;
        &__icon {
            margin: auto 0 auto .5rem;
        }
    }
</style>
